import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Icon, { ICONS, COLORS } from '../../../../../general-ui/icon';
import { SocialLink, Speaker } from '../../../../../../types/working-model';
import classNames from 'classnames';
import { TemplateClassNames } from '../../../../../../types/template-layouts';
import { TypographyItem } from '../../../../../general-ui/typography-item/typography-item';
import { useParams } from 'react-router';

interface ISpeakerCardProps {
	id: string;
	speaker: Speaker;
	editSpeaker: (s: Speaker) => () => void;
	checkDeleteSpeaker: (s: Speaker) => () => void;
	replaceSpeaker: (s: Speaker) => () => void;
	template: TemplateClassNames;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function SpeakerCard(props: ISpeakerCardProps): JSX.Element {
	const { attributes, listeners, setNodeRef, transform } = useSortable({
		id: props.id,
	});
	const { language } = useParams() as any;
	const {
		speaker,
		editSpeaker,
		checkDeleteSpeaker,
		replaceSpeaker,
		template
	} = props;

	const style = {
		transform: CSS.Transform.toString(transform),
		transition: 'none',
	};

	return (
		<div
			ref={setNodeRef}
			style={style}
			{...attributes}
			{...listeners}
			className="speaker"
		>
			<img src={speaker.image} alt={speaker.first_name} />
			<div className="speaker-data">
				<TypographyItem
					className={classNames('speaker-name', {
						'evt-heading-3': template === TemplateClassNames.Apollo,
						'evt-heading-4': template !== TemplateClassNames.Classic,
					})}
					tagName="h3"
					template={template}
				>
					{speaker.first_name} {speaker.last_name}
				</TypographyItem>
				<TypographyItem
					className={classNames('speaker-job-title')}
					tagName="h5"
				>
					{speaker.job_title?.[language] ?? speaker.job_title?.base}
				</TypographyItem>
				<TypographyItem
					tagName="p"
					className="description"
					template={template}
				>
					{speaker.description[language] || speaker.description.base}
				</TypographyItem>
				<div className="social-links">
					{speaker.link_social && speaker.social_links?.map(({ platform, url }: SocialLink, i: number) => <a href={url} target="_blank" rel="noreferrer" key={url + i}><Icon name={platform} color={COLORS.ACCENT_BLUE} size={13} /></a>)}
				</div>
			</div>

			<div className="edit-actions">
				<button className="round" onClick={editSpeaker(speaker)}>
					<Icon name={ICONS.EDIT} size={12} color={COLORS.WHITE} />
				</button>
				<button className="round" onClick={replaceSpeaker(speaker)}>
					<Icon name={ICONS.ARROW_CIRCLE} size={12} color={COLORS.WHITE} />
				</button>
				<button className="round" onClick={checkDeleteSpeaker(speaker)}>
					<Icon name={ICONS.TRASH} size={12} color={COLORS.WHITE} />
				</button>
			</div>
		</div>
	);
}
